import * as React from "react";
export default class Divider extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "divider" },
            React.createElement("div", { className: "lines" }),
            React.createElement("h2", null, this.props.children),
            React.createElement("div", { className: "lines" })));
    }
}
;
//# sourceMappingURL=divider.js.map